<template>
    <transition name="dropdown">
        <div :class="dropdown ? 'dropdown-filter' : 'panel-filter'">
            <div class="row no-gutters" v-if="hasSelection">
                <div class="alink mr-1" v-if="filter.data" @click="onRemove('data')">
                    <span class="mr-2">DATA</span><b>{{filterDataValue}}</b>
                </div>
                <div class="alink mr-1" v-if="filter.prezzo" @click="onRemove('prezzo')">
                    <span class="mr-2">PREZZO</span>
                    <b class="mr-1">&euro; {{minPriceF}}</b>-
                    <b>&euro; {{maxPriceF}}</b>
                </div>
                <div class="alink" v-if="filter.nome" @click="onRemove('nome')">
                    <span class="mr-2">NOME</span><b>{{filter.nome}}</b>
                </div>
            </div>
            <div class="bg-white">
                <form @submit.prevent>
                    <div class="form-group">
                        <label>Data</label>
                        <div :class="isDropdown ? 'px-3 px-md-5 py-2 py-md-3 bg-light' : 'p-3 bg-light'">
                            <CustomDatePicker :open-date="filterOpenDate" :value="filter.data" :disabled-dates="disabledDates" class="bg-white" style="max-width: 250px" @input="onInputData"/>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Prezzo</label>
                        <div :class="isDropdown ? 'px-3 px-md-5 py-2 py-md-3 bg-light' : 'p-3 bg-light'">
                            <PriceRangeSlider :min-price="minPrice" :max-price="maxPrice" :value="filter.prezzo" @input="onInputPrezzo"/>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Nome</label>
                        <div :class="isDropdown ? 'px-3 px-md-5 py-2 py-md-3 bg-light' : 'p-3 bg-light'">
                            <input class="form-control" type="text" name="nome" :value="filter.nome" @input="onInputNome"/>
                        </div>
                    </div>
                    <div v-if="isMobile">
                        <button class="btn btn-primary" @click="$emit('close')">chiudi</button>
                    </div>
                </form>
            </div>
        </div>
    </transition>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import PriceRangeSlider from '../../common/PriceRangeSlider'
import {formatMoney, longDateFormatter} from '../../../../utils/formatter'
import CustomDatePicker from '../CustomDatePicker'
import AnalyticEvents from '../../../common/AnalyticEvents'
import MobileDetector from '../../../common/MobileDetector'

export default {
  name: 'DropdownFilterService',
  mixins: [AnalyticEvents, MobileDetector],
  components: {CustomDatePicker, PriceRangeSlider},
  props: {
    value: Object,
    list: Array,
    isTrasferimento: {
      type: Boolean,
      default: false
    },
    isDropdown: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    filterOpenDate () {
      const search = this.getItinerario().search
      return search.andata ? search.andata : search.partenza
    },
    disabledDates () {
      const search = this.getItinerario().search
      const days = this.getItinerario().days.length
      const andata = search.andata ? search.andata : search.partenza
      const ritorno = this.$moment(andata).add(days, 'days').toDate()
      return {
        to: andata,
        from: ritorno
      }
    },
    dropdown () {
      return this.isDropdown === true
    },
    filterDataValue () {
      return longDateFormatter(this.filter.data)
    },
    filter () {
      return this.value
    },
    hasSelection () {
      return this.filter.prezzo || this.filter.data || this.filter.nome
    },
    prices () {
      return this.list.map(item => {
        return item.venditaTotaleEuro
      })
    },
    minPrice () {
      return this.prices && this.prices.length > 0 ? this.prices.reduce((totale, current) => {
        return Math.min(totale, current)
      }) : 0
    },
    maxPrice () {
      return this.prices && this.prices.length > 0 ? this.prices.reduce((totale, current) => {
        return Math.max(totale, current)
      }) : 0
    },
    minPriceF () {
      return formatMoney(this.filter.prezzo[0])
    },
    maxPriceF () {
      return formatMoney(this.filter.prezzo[1])
    }
  },
  methods: {
    ...mapGetters(['getItinerario']),
    ...mapActions(['modifyServiziFilter', 'modifyTrasferimentoFilter']),
    onInputNome (event) {
      const { value } = event.target
      const filter = {...this.filter, nome: value}
      this.onChangeFilter(filter)
    },
    onInputPrezzo (value) {
      this.trackModaleListaAttivitaPrezzoMappa()
      const filter = {...this.filter, prezzo: value}
      this.onChangeFilter(filter)
    },
    onInputData (value) {
      this.trackModaleListaAttivitaFiltroData()
      const filter = {...this.filter, data: value}
      this.onChangeFilter(filter)
    },
    onSelect (property, item) {
      const filter = {...this.filter, [property]: item}
      this.onChangeFilter(filter)
    },
    onRemove (property) {
      const filter = {...this.filter, [property]: null}
      this.onChangeFilter(filter)
    },
    onChangeFilter: function (filter) {
      if (this.isTrasferimento) {
        this.modifyTrasferimentoFilter(filter)
      } else {
        this.modifyServiziFilter(filter)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/dropdown/DropdownFilterService.vue